export const isAllowedToManageOrder = user => {
    return user.position?.toLowerCase() === "cibus";
};
